// App management roles
export const APP_ROLES = {
  ADD_APP: 'app:add',
  EDIT_APP: 'app:edit',
  DELETE_APP: 'app:delete',
  VIEW_APP: 'app:view',
};

// Stats viewing roles
export const STATS_ROLES = {
  VIEW_STATS: 'stats:view',
  EXPORT_STATS_TO_NOTION: 'stats:make-report-to-notion:get',
  VIEW_STATS_TEMPLATE: 'stats:report-template-monthly:view',
  UPDATE_STATS_TEMPLATE: 'stats:report-template-monthly:update',
};

export const FEATURE_REQUEST_ROLES = {
  DELETE_FEATURE_REQUEST: 'feature-requests:requests:delete',
  ADD_FEATURE_REQUEST: 'feature-requests:requests:add',
  EDIT_FEATURE_REQUEST: 'feature-requests:requests:edit',
  DELETE_COMMENT_FEATURE_REQUEST: 'feature-requests:comment:delete',
  BLOCK_USERS_FEATURE_REQUEST: 'feature-requests:user:block',
};

export const NOTION_REPORT_TEMPLATE_ROLES = {
  VIEW_TEMPLATE: 'template:notion:view',
  UPDATE_TEMPLATE: 'template:notion:update',
  DELETE_TEMPLATE: 'template:notion:delete',
  ADD_TEMPLATE: 'template:notion:add',
};

// User management roles
export const USER_ROLES = {
  ADD_USER: 'user:add',
  EDIT_USER: 'user:edit',
  DELETE_USER: 'user:delete',
  VIEW_USER: 'user:view',
};

export const TRAFFIC_ROLES = {
  VIEW_TRAFFIC: 'traffic:view',
  ADD_PARTNER: 'partner:add',
  EDIT_PARTNER: 'partner:edit',
  DELETE_PARTNER: 'partner:delete',
};

// Team management roles
export const TEAM_ROLES = {
  ADD_TEAM: 'team:add',
  EDIT_TEAM: 'team:edit',
  DELETE_TEAM: 'team:delete',
  VIEW_TEAM: 'team:view',
};

export const SALE_ROLES = {
  VIEW_POTENTIAL_CUSTOMERS: 'sale:potential-customers:view',
};

// All available roles
export const ALL_ROLES = [
  ...Object.values(APP_ROLES),
  ...Object.values(STATS_ROLES),
  ...Object.values(USER_ROLES),
  ...Object.values(TRAFFIC_ROLES),
  ...Object.values(TEAM_ROLES),
  ...Object.values(SALE_ROLES),
  ...Object.values(NOTION_REPORT_TEMPLATE_ROLES),
  ...Object.values(FEATURE_REQUEST_ROLES),
];

export const ADMIN_EMAILS = [
  'anhnt@avada.io',
  'sam@avada.io',
  'anhth@avada.io',
  'lamln@avadagroup.com',
  'nghiavt@avadagroup.com',
  'nghiavt@avada.email',
  'anhth01@avadagroup.com',
  'truongnn@avadagroup.com',
];
